export const CHAT_WS_AUTH_CODES = new Set([4401, 4403]);

export const chatAccessToken = () => localStorage.getItem('serviceToken') || '';

export const isChatWsAuthClose = (code) => CHAT_WS_AUTH_CODES.has(Number(code));

export const isChatHttpAuthError = (err) => {
  const status = err?.response?.status;
  return status === 401 || status === 403;
};

export const chatWsBackoffMs = (attempt) => Math.min(1000 * (2 ** attempt), 30000);

export const chatWsBusy = (socket) => {
  if (!socket) return false;
  return socket.readyState === WebSocket.CONNECTING || socket.readyState === WebSocket.OPEN;
};
